import AppointmentResources from './AppointmentResources'

export default AppointmentResources